<script setup lang="ts">
import useCompanyName from '@Use/useCompanyName';
import { ErrorScreenLayout, SupportEmailLink } from '@Shared';
import BrowserError from '@Assets/images/browser_error.svg';
import AuthErrorShell from '@Components/AuthErrorShell.vue';

const { companyName } = useCompanyName();
</script>

<template>
    <auth-error-shell class="unable-to-process-view">
        <div class="unable-to-process-view__content">
            <error-screen-layout
                :image="BrowserError"
                image-alt="Unable to process"
                title="We couldn't complete your request"
                image-width="12rem"
                image-height="10rem">
                <p>
                    To protect you and your transaction, access to this request has been blocked.
                </p>
                <p>
                    {{ companyName }} has been notified. They will reach out directly with next steps.
                    If you have any technical issues, please contact <support-email-link />.
                </p>
            </error-screen-layout>
        </div>
    </auth-error-shell>
</template>

<style lang="scss" scoped>
@use 'certifid-v2-client-hub-styles' as *;

.unable-to-process-view {
    @include desktop {
        padding-top: 10.25rem;
    }

    &__content {
        border-radius: 0.25rem;
        background-color: $white;
        max-width: 24.5rem;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 2rem;
        line-height: 150%;
        color: $black-high;
    }
}
</style>
